// extracted by css-extract-rspack-plugin
export default {"iconSmall":"iconSmall__PK1UJ","iconMedium":"iconMedium__ra3DJ"};